import { SimpleGuard } from 'interfaces/guards'
import { getFeedTagsActionCreator, getRandomFeedRelationActionCreator } from 'actions/feedActions'
import { tagsByPopularitySelector, tagsByTrendSelector, filterRandomRelationStateSelector } from 'selectors/feedSelectors'
import { TagsOrdering, FeedTag } from 'interfaces/feed'
import { State } from 'interfaces/state'
import { WithRequestDetails } from 'interfaces/ajax/base'
import { FEED_TRENDING_TAGS_LIMIT, FEED_POPULAR_TAGS_LIMIT } from 'constants/feed'

type GuardHelper = {
  name: string
  limit: number
  selector: (state: State, ownProps: { form?: string }) => WithRequestDetails<FeedTag[] | null> | null
}
const GUARD_HELPERS_MAP: Record<string, GuardHelper> = {
  '-popularity': {
    name: `tagsByPopularity`,
    selector: tagsByPopularitySelector,
    limit: FEED_POPULAR_TAGS_LIMIT,
  },
  '-trend': {
    name: `tagsByTrend`,
    selector: tagsByTrendSelector,
    limit: FEED_TRENDING_TAGS_LIMIT,
  },
}

const createTagsByOrderingGuard = (ordering: TagsOrdering): SimpleGuard<{}> => {
  const { name, limit, selector } = GUARD_HELPERS_MAP[ordering]

  return {
    name,
    checker: (state, ownProps) => Boolean(selector(state, ownProps)),
    loader: (dispatch) => dispatch(getFeedTagsActionCreator.request({
      ordering,
      limit,
    })),
  }
}

export const tagsByPopularityGuard = createTagsByOrderingGuard('-popularity')
export const tagsByTrendGuard = createTagsByOrderingGuard('-trend')


export const randomFeedRelationGuard: SimpleGuard = {
  name: 'Random Feed Relation Guard',
  checker: (state) => {
    const randomFeedRelationState = filterRandomRelationStateSelector(state)
    return randomFeedRelationState.isLoading || !!randomFeedRelationState.data
  },
  loader: (dispatch) => dispatch(getRandomFeedRelationActionCreator.request({})),
}
